import Modal from "modal/Modal";
import FormValidator from "base/FormValidator";
import ContentPostSettingsModalTab from "content/tabs/ContentPostSettingsModalTab";
import SEOSettingsTab from "content/tabs/SEOSettingsTab";
import DeleteTab from "content/tabs/DeleteTab";

class ContentPostSettingsModal extends Modal {
    constructor(contentPost, tab = null) {
        super({class: "admin-modal--navigation"});
        this.firstShow = true;

        this.contentPost = contentPost;
        this.tabs = [];

        let $content = (
            eotwJSXFactory('form', {class: "admin-form"}, [
                eotwJSXFactory('div', {class: "admin-modal__navigation js-tabs"}),
                eotwJSXFactory('div', {class: "js-tab-content admin-form__col admin-form__col--full"}),
                eotwJSXFactory('div', {class: "admin-modal__buttons"}, [
                    eotwJSXFactory('button', {class: "admin-btn admin-btn--confirm admin-btn--modal", type: "submit"}, ["Ok"]),
                    eotwJSXFactory('button', {class: "admin-btn admin-btn--cancel admin-btn--modal js-cancel"}, ["Cancel"])
                ])
            ])
        );

        this.setContent($content);

        this.validator = FormValidator.attach($content).on("submit", () => {
            let data = {};
            this.tabs.forEach((tab) => {
                let values = tab.tab.getValues();
                Object.keys(values).forEach((key) => {
                    data[key] = values[key];
                });
            });

            contentPost.setInputData(data);

            this.emit("submit");
            this.hide();
        });

        const me = this;
        this.on("click", ".js-cancel", () => {
            this.emit("cancel");
            this.hide();
            return false;
        }).on("click", ".js-tabs button", function () {
            me.showTab($(this).data("tab"));
        });

        this.on("show", () => {
            if (!this.firstShow) return;
            this.firstShow = false;

            this.buildDefaultTabs();

            this.sortTabs();
            if (tab) {
                this.showTab(tab);
            } else {
                let $first = this.$content.find(".js-tabs button").first();
                if ($first.length > 0) {
                    $first.click();
                } else {
                    console.warn("No tabs in content post settings modal", this);
                }
            }
        })
    }

    buildDefaultTabs() {
        if ('undefined' !== typeof this.contentPost.workingRevision.values['meta-title'] || 'undefined' !== typeof this.contentPost.workingRevision.values['meta-description']) {
            if (this.emit("addSEOSettingsTab")) this.addTab(new SEOSettingsTab(this.contentPost), 100);
        }
        if (this.contentPost.id) {
            if (this.emit("addDeleteTab")) this.addTab(new DeleteTab(this.contentPost), -100);
        }
    }

    /**
     * @param {ContentPostSettingsModalTab} tab
     */
    addTab(tab, priority = 1) {
        tab.modal = this;
        this.tabs.push({
            tab: tab,
            priority: priority
        });

        let $button = tab.getTabButton();
        $button.data("tab", tab);

        this.$content.find(".js-tab-content").append(tab.getElement().hide());

        if (this.shown) {
            this.sortTabs();
        }
        this.validator.updateInputs();
    }

    sortTabs() {
        this.tabs.sort((a, b) => b.priority - a.priority);

        this.$content.find(".js-tabs").html(this.tabs.map((tab) => tab.tab.getTabButton().detach()));
    }

    /**
     * @param {ContentPostSettingsModalTab} tab
     */
    showTab(tab) {
        if ("undefined" === typeof tab) {
            console.trace("Tried to show undefined tab!");
            return;
        }
        if ("string" === typeof tab) {
            let filteredTabs = this.$content.find(".js-tabs button").filter((_, el) => $(el).text() === tab);
            if (filteredTabs.length === 0) {
                console.trace("Tried to show an invalid tab", tab);
            }
            tab = $(filteredTabs[0]).data("tab");
        }
        this.$content.find(".js-tabs button").removeClass("admin-modal__link--active");
        this.$content.find(".js-tab-content").children().hide();

        tab.getElement().show();
        tab.getTabButton().addClass('admin-modal__link--active');

    }

    destroy() {
        super.destroy();

        this.tabs.forEach((tab) => tab.tab.destroy());
    }
}

export default ContentPostSettingsModal;
